export function licensePrintLayout(geometry,crop) {
 if(!geometry)return null;
 const ratio=geometry.source_width*crop.width/(geometry.source_height*crop.height);
 if(Math.abs(ratio-471.42/360)>.002)return {error:"Align the license inside the fixed rectangular frame."};
 return {width:471.42,height:360,left:160.29,top:126,paperWidth:792,paperHeight:612,photoLeft:414.41,photoTop:203.92};
}
